// extracted by mini-css-extract-plugin
export default {"messageWrapper":"Message_messageWrapper__6NnuL","offerNumber":"Message_offerNumber__MfeMb","showMoreBtn":"Message_showMoreBtn__L4GdY"};